import type { UnionTypeLibelle } from '../../../techniques'

export const ObjectifFormation = [
  'AcquisitionCompetencesPrealableEmploi',
  'AdaptationMaintienEmploi',
  'CreationRepriseEntreprise',
  'Autres',
  'CompetencesClesIlletrisementSavoirsBase',
  'DeveloppementCompetencesProfessionnelles',
  'FormationsQualifiantesCertifiantes',
  'MobilisationRemobiliationAideProjetProfessionnel',
  'PreparationAccesQualification',
  'Reconversion',
] as const

export type ObjectifFormation = (typeof ObjectifFormation)[number]

export const ObjectifFormationLibelle: UnionTypeLibelle<ObjectifFormation> = {
  AcquisitionCompetencesPrealableEmploi: 'Acquisition de compétences préalable à l’emploi',
  AdaptationMaintienEmploi: 'Adaptation au poste / maintien dans l’emploi',
  CreationRepriseEntreprise: 'Appui à la création / reprise d’entreprise',
  Autres: 'Autres',
  CompetencesClesIlletrisementSavoirsBase: 'Compétences clés, illettrisme, savoirs de base',
  DeveloppementCompetencesProfessionnelles: 'Développement des compétences professionnelles des salariés',
  FormationsQualifiantesCertifiantes: 'Formations qualifiantes / certifiantes au service du retour à l’emploi',
  MobilisationRemobiliationAideProjetProfessionnel:
    "Mobilisation, remobilisation, aide à l'élaboration d'un projet professionnel",
  PreparationAccesQualification: 'Préparation à l’accès à la qualification',
  Reconversion: 'Reconversion',
} as const
